import { pagesConfig } from '../../../shared/pages-config';
import SimpleBreadcrumbsPage from '../../../shared/simple-breadcrumbs-page';
import { useRouteMatch } from '../../../shared/useRouteMatch';
import { Outlet } from 'react-router-dom';
import ResourceTemplatesGrid from './resource-templates-grid';
import { ModuleList } from '../../../shared/analytics/module-list';

export default function ResourceTemplatesPage() {
  const isFormPage = useRouteMatch([
    `${pagesConfig.resourceTemplates.link}/${pagesConfig.createResourceTemplate.link}`,
    `${pagesConfig.resourceTemplates.link}/${pagesConfig.editResourceTemplate.link}`,
  ]);
  if (isFormPage) return <Outlet />;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: ModuleList.modules.calendars.name },
        { label: pagesConfig.resourceTemplates.name },
      ]}
      bookmarkKey={pagesConfig.resourceTemplates.value}
    >
      <ResourceTemplatesGrid />
    </SimpleBreadcrumbsPage>
  );
}
